import React, { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "./byteacherchart.scss";
import { useQuery } from "@apollo/client";

import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import { GET_STUDENT_DROP_OUT_SHOW_BY_CLASSES } from "../../../Schema/Dashboard";

import LoadingPage from "../../Include/LoadingPage";

export default function DropOutChartByTeacher({ academicYearId, schoolId, teacherId, teacherName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_STUDENT_DROP_OUT_SHOW_BY_CLASSES, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      teacherId: teacherId ?? null
    },
    onCompleted: ({ getStudentDropOutChartShowByClasses }) => {
      setTotalData(getStudentDropOutChartShowByClasses);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const classData = totalData?.map((e) => {
    return e?.levelName + " " + e?.groupName;
  });

  const totalStudent = totalData?.map((e) => e?.totalStudent);
  const totalFemale = totalData?.map((e) => e?.female);

  // const maxSeriesData = Math.max(...(totalStudent?.length ? totalStudent : []));

  useEffect(() => {
    refetch();
  }, [academicYearId, schoolId, teacherId]);

  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: classData,
        // categories: ["A", "B", "C", "D", "E"],
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " នាក់";
            } else {
              return 0 + " នាក់";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("total_student"),
        data: totalStudent,
        // data: [10, 15, 20, 25, 30],
        color: "#F44236",
      },
      {
        name: t("total_female"),
        data: totalFemale,
        // data: [5, 10, 15, 20, 25],
        color: "#FEC009",
      },
    ],
  };

  return (
    <Box className="total-enrollment-by-teacher-chart">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("total_drop_out_chart_by_teacher")} {teacherName}
        </Typography>
      </Stack>

      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={350}
            />
          </div>
      }
    </Box>
  );
}
